import { NgModule, InjectionToken } from "@angular/core";
import { NgxCurrencyModule, CurrencyMaskInputMode, CurrencyMaskConfig } from "ngx-currency";

export const customCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  allowZero: false,
  decimal: ".",
  precision: 2,
  prefix: "$ ",
  suffix: "",
  thousands: ",",
  nullable: true,
  min: null,
  max: null,
  inputMode: CurrencyMaskInputMode.NATURAL,
};

@NgModule({
  imports: [NgxCurrencyModule.forRoot(customCurrencyMaskConfig)],
  exports: [NgxCurrencyModule],
})
export class NgxCurrencyMaskModule {}
